// Tela de login do viajante.

export const pt = {
  company: 'Empresa',
  companyPlaceholder: 'ex.: serviquim',
  email: 'E-mail',
  password: 'Senha',
  submit: 'Entrar',
  errors: {
    fillAll: 'Preencha todos os campos',
    offline: 'Sem conexão. É preciso estar online pra entrar pela primeira vez.',
    generic: 'Não foi possível entrar. Tente novamente.',
  },
};

export const es: typeof pt = {
  company: 'Empresa',
  companyPlaceholder: 'ej.: serviquim',
  email: 'Correo electrónico',
  password: 'Contraseña',
  submit: 'Ingresar',
  errors: {
    fillAll: 'Complete todos los campos',
    offline: 'Sin conexión. Debe estar en línea para ingresar por primera vez.',
    generic: 'No se pudo ingresar. Inténtelo de nuevo.',
  },
};
